var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 160,
    viewBox: "0 0 286 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 285,
    height: 125
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17.0518,
    width: 284.938,
    height: 124.058,
    fill: "url(#paint0_linear_4_179)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.225 33.345L233.12 27.9651L166.793 28.1726L155.312 24.0481L145.597 28.0837L104.085 27.97L87.6362 20.4277H63.7192L60.0198 27.9675H39.1746L0 90.3523L43.6081 139.575H241.423L285.031 90.3523L249.223 33.3425L249.225 33.345ZM240.418 137.344H44.6139L2.78265 90.1249L40.4127 30.1991H61.416L65.1131 22.6592H87.1494L103.593 30.1991L146.04 30.3152L155.369 26.4378L166.406 30.4042L232.759 30.1966L247.757 35.2059L282.249 90.12L240.418 137.339V137.344Z",
    fill: "url(#paint1_linear_4_179)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.251 90.1247L240.418 137.341H44.6138L2.78259 90.1247L40.4126 30.1989H61.416L65.113 22.659H87.1493L103.596 30.1989L146.04 30.3175L155.369 26.4401L166.405 30.4065L232.759 30.1989L247.757 35.2106L282.251 90.1247Z",
    fill: "url(#paint2_linear_4_179)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.246 90.1247L247.759 35.2106L232.756 30.2013L166.407 30.4039L155.371 26.4375L146.037 30.315L103.593 30.2013L87.1488 22.6614H65.1149L61.4179 30.2013H40.4171L2.78455 90.1247H27.9495L46.9165 104.223H77.6344L82.2334 90.1247H102.159L106.739 70.1766H111.283L117.422 67.5027L116.134 81.0403L133.107 90.1247H282.246Z",
    fill: "#4A357D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1102 82.7579H37.5485L41.2332 75.6901H31.7262L38.453 63.8972L49.4749 59.8838L52.9569 53.2114L42.4663 56.8615L48.0489 47.0728L44.7597 42.103H50.886H58.7495L61.1146 37.5683H44.4903L16.1102 82.7579Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7097 30.0257L57.2644 55.4205L72.354 64.3764L78.2751 67.4358L69.3143 72.3017L62.9903 88.7826H52.8408L63.6946 63.6918L55.5864 58.8432L40.2571 90.1171L49.3489 96.8563H72.2897L83.6551 62.0015L68.1231 53.4533L76.4834 34.128H83.9566L89.0424 36.2657L81.8486 39.6241L76.9382 52.4278L85.3084 56.9255L92.9594 33.4608L85.5308 30.0257H69.7097Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6869 37.5678L84.7078 82.7574H96.2906L100.872 62.8093H109.749L120.776 58.0077L122.82 41.4155L114.309 37.5678H97.6844H97.6869ZM112.571 47.2033L110.792 57.0513H102.197L105.63 42.1001H113.493L119.296 44.4602L112.571 47.2008V47.2033Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.668 37.5678L123.932 76.8585L134.954 82.7574H156.392L153.543 41.4155L144.295 37.5678H127.671H127.668ZM144.451 51.4711L144.728 75.6871H135.221L136.483 42.1001H144.347L150.389 44.4602L144.453 51.4711H144.451Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.881 41.4328L164.367 82.7574H175.95L172.636 62.8093H181.513L185.803 82.7574H197.388L192.191 63.6916L185.373 60.8051L190.641 58.0077L185.069 37.5678H168.444L159.881 41.4328ZM180.277 57.0513H171.682L170.056 47.2552L163.349 44.4626L169.198 42.1026H177.062L180.277 57.0537V57.0513Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.366 42.1026H197.109L210.925 82.7574H222.511L208.306 47.013L200.193 42.0482H213.953L211.961 37.5678H188.044L189.366 42.1026Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.7 56.9252L242.926 41.3637L231.558 37.5678H214.934L223.217 55.4202L246.85 64.3761L253.305 75.6896H243.796L237.541 63.6916L224.804 58.8429L233.162 76.8585L247.483 82.7574H268.921L255.885 62.0012L232.2 53.4531L228.882 47.0871L220.16 42.1026H234.145L240.034 52.4275L252.7 56.9252Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.759 32.1531C154.545 33.3369 153.171 34.4341 151.661 35.43C153.312 36.4358 154.881 37.5825 156.347 38.8503C157.59 37.5825 158.959 36.4358 160.432 35.43C158.746 34.4341 157.179 33.3369 155.759 32.1531Z",
    fill: "#E2D45C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1737 77.1725L36.1303 64.9743C33.5503 65.2684 30.9925 65.5699 28.457 65.8838L18.7919 81.2748H36.6493L38.7869 77.1725H29.1737Z",
    fill: "url(#paint3_linear_4_179)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0514 61.1609C76.2885 61.3413 73.5429 61.534 70.8146 61.7391L73.0734 63.0786L80.4946 66.9115L81.8637 62.7079L79.0514 61.1609ZM70.5008 73.3418L64.0112 90.265H50.5848L61.8192 64.2969L59.1156 62.6807C57.8009 62.7944 56.4887 62.9105 55.1838 63.0316L42.1331 89.6596L49.8385 95.3731H71.2125L80.0943 68.1348L70.5008 73.3418Z",
    fill: "url(#paint4_linear_4_179)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.711 59.468L109.444 61.3264H99.6944L95.1127 81.2745H86.6782L92.6859 60.3552C99.6005 59.992 106.611 59.6954 113.711 59.468Z",
    fill: "url(#paint5_linear_4_179)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.803 81.2748H135.327L125.501 76.0184L127.11 59.1174C129.519 59.0679 131.936 59.0284 134.363 58.9963L133.681 77.1725H146.228L146.02 58.8999C147.13 58.8974 148.242 58.895 149.356 58.895C150.661 58.895 151.963 58.8974 153.261 58.9024L154.803 81.2748Z",
    fill: "url(#paint6_linear_4_179)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.448 81.2746H187.001L182.711 61.3265H170.886L174.2 81.2746H165.696L163.277 58.9813C170.513 59.0703 177.672 59.2309 184.745 59.4583L181.925 60.9558L190.95 64.7764L195.448 81.2746Z",
    fill: "url(#paint7_linear_4_179)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.147 60.6938C209.73 60.5529 207.301 60.4195 204.859 60.2959L211.989 81.2745H220.327L212.147 60.6938Z",
    fill: "url(#paint8_linear_4_179)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M255.52 64.2058C253.042 63.9463 250.546 63.6943 248.03 63.4521L255.859 77.1726H242.897L236.487 64.878L228.324 61.7692C228.141 61.7543 227.961 61.742 227.778 61.7296L234.265 75.7096L247.775 81.2749H266.241L255.52 64.2058Z",
    fill: "url(#paint9_linear_4_179)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9786 25.9287C15.305 17.8946 22.0219 11.5632 31.9366 7.11248C41.4362 2.84707 53.4738 0.474649 67.7108 0.0644182C96.8965 -0.778285 132.129 6.6899 166.913 21.0999C169.413 22.1353 171.892 23.198 174.344 24.2878L170.876 24.2977C169.389 23.6527 167.889 23.0176 166.376 22.3924C95.1122 -7.12451 26.4282 -5.29824 13.2711 26.465C9.46042 35.6631 10.7183 46.376 16.16 57.6747C29.5024 85.3974 68.0221 116.637 118.654 137.608C123.552 139.637 128.455 141.525 133.35 143.272C163.052 153.879 192.389 159.254 217.279 158.535C231.334 158.129 243.188 155.799 252.52 151.61C262.101 147.31 268.573 141.228 271.759 133.535C274.633 126.593 274.623 118.789 272.105 110.52L273.18 109.307C276.13 118.421 276.091 126.742 273.054 134.072C269.725 142.106 263.01 148.437 253.093 152.888C243.594 157.153 231.559 159.526 217.322 159.936C215.834 159.978 214.331 160 212.814 160C187.723 160 158.579 154.151 129.258 143.272C125.543 141.896 121.829 140.438 118.117 138.9C83.3341 124.493 53.1401 104.864 33.0981 83.628C25.2172 75.2776 19.2467 67.0383 15.2902 59.0586C14.3362 57.1384 13.501 55.2355 12.7843 53.35C8.92168 43.1906 8.64985 33.9653 11.9786 25.9287Z",
    fill: "url(#paint10_linear_4_179)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9786 25.9287C15.305 17.8946 22.0219 11.5632 31.9366 7.11248C41.4362 2.84707 53.4738 0.474649 67.7108 0.0644182C96.8965 -0.778285 132.129 6.6899 166.913 21.0999C169.413 22.1353 171.892 23.198 174.344 24.2878L170.876 24.2977C169.389 23.6527 167.889 23.0176 166.376 22.3924C95.1122 -7.12451 26.4282 -5.29824 13.2711 26.465C9.46042 35.6631 10.7183 46.376 16.16 57.6747C29.5024 85.3974 68.0221 116.637 118.654 137.608C123.552 139.637 128.455 141.525 133.35 143.272C163.052 153.879 192.389 159.254 217.279 158.535C231.334 158.129 243.188 155.799 252.52 151.61C262.101 147.31 268.573 141.228 271.759 133.535C274.633 126.593 274.623 118.789 272.105 110.52L273.18 109.307C276.13 118.421 276.091 126.742 273.054 134.072C269.725 142.106 263.01 148.437 253.093 152.888C243.594 157.153 231.559 159.526 217.322 159.936C215.834 159.978 214.331 160 212.814 160C187.723 160 158.579 154.151 129.258 143.272C125.543 141.896 121.829 140.438 118.117 138.9C83.3341 124.493 53.1401 104.864 33.0981 83.628C25.2172 75.2776 19.2467 67.0383 15.2902 59.0586C14.3362 57.1384 13.501 55.2355 12.7843 53.35C8.92168 43.1906 8.64985 33.9653 11.9786 25.9287Z",
    fill: "url(#paint11_radial_4_179)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9786 25.9287C15.305 17.8946 22.0219 11.5632 31.9366 7.11248C41.4362 2.84707 53.4738 0.474649 67.7108 0.0644182C96.8965 -0.778285 132.129 6.6899 166.913 21.0999C169.413 22.1353 171.892 23.198 174.344 24.2878L170.876 24.2977C169.389 23.6527 167.889 23.0176 166.376 22.3924C95.1122 -7.12451 26.4282 -5.29824 13.2711 26.465C9.46042 35.6631 10.7183 46.376 16.16 57.6747C29.5024 85.3974 68.0221 116.637 118.654 137.608C123.552 139.637 128.455 141.525 133.35 143.272C163.052 153.879 192.389 159.254 217.279 158.535C231.334 158.129 243.188 155.799 252.52 151.61C262.101 147.31 268.573 141.228 271.759 133.535C274.633 126.593 274.623 118.789 272.105 110.52L273.18 109.307C276.13 118.421 276.091 126.742 273.054 134.072C269.725 142.106 263.01 148.437 253.093 152.888C243.594 157.153 231.559 159.526 217.322 159.936C215.834 159.978 214.331 160 212.814 160C187.723 160 158.579 154.151 129.258 143.272C125.543 141.896 121.829 140.438 118.117 138.9C83.3341 124.493 53.1401 104.864 33.0981 83.628C25.2172 75.2776 19.2467 67.0383 15.2902 59.0586C14.3362 57.1384 13.501 55.2355 12.7843 53.35C8.92168 43.1906 8.64985 33.9653 11.9786 25.9287Z",
    fill: "url(#paint12_radial_4_179)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9786 25.9287C15.305 17.8946 22.0219 11.5632 31.9366 7.11248C41.4362 2.84707 53.4738 0.474649 67.7108 0.0644182C96.8965 -0.778285 132.129 6.6899 166.913 21.0999C169.413 22.1353 171.892 23.198 174.344 24.2878L170.876 24.2977C169.389 23.6527 167.889 23.0176 166.376 22.3924C95.1122 -7.12451 26.4282 -5.29824 13.2711 26.465C9.46042 35.6631 10.7183 46.376 16.16 57.6747C29.5024 85.3974 68.0221 116.637 118.654 137.608C123.552 139.637 128.455 141.525 133.35 143.272C163.052 153.879 192.389 159.254 217.279 158.535C231.334 158.129 243.188 155.799 252.52 151.61C262.101 147.31 268.573 141.228 271.759 133.535C274.633 126.593 274.623 118.789 272.105 110.52L273.18 109.307C276.13 118.421 276.091 126.742 273.054 134.072C269.725 142.106 263.01 148.437 253.093 152.888C243.594 157.153 231.559 159.526 217.322 159.936C215.834 159.978 214.331 160 212.814 160C187.723 160 158.579 154.151 129.258 143.272C125.543 141.896 121.829 140.438 118.117 138.9C83.3341 124.493 53.1401 104.864 33.0981 83.628C25.2172 75.2776 19.2467 67.0383 15.2902 59.0586C14.3362 57.1384 13.501 55.2355 12.7843 53.35C8.92168 43.1906 8.64985 33.9653 11.9786 25.9287Z",
    fill: "url(#paint13_radial_4_179)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M273.053 25.9287C269.727 17.8946 263.01 11.5632 253.095 7.11248C243.596 2.84707 231.558 0.474649 217.321 0.0644182C188.136 -0.778285 152.903 6.6899 118.12 21.0999C115.619 22.1353 113.14 23.198 110.688 24.2878L114.156 24.2977C115.643 23.6527 117.143 23.0176 118.656 22.3924C189.92 -7.12451 258.604 -5.29824 271.761 26.465C275.572 35.6631 274.314 46.376 268.872 57.6747C255.53 85.3974 217.01 116.637 166.379 137.608C161.48 139.637 156.577 141.525 151.682 143.272C121.98 153.879 92.6432 159.254 67.7526 158.535C53.6985 158.129 41.8438 155.799 32.5123 151.61C22.9311 147.31 16.4589 141.228 13.2734 133.535C10.3993 126.593 10.4092 118.789 12.9274 110.52L11.8524 109.307C8.90173 118.421 8.94127 126.742 11.9785 134.072C15.3073 142.106 22.0217 148.437 31.9389 152.888C41.4385 157.153 53.4736 159.526 67.7106 159.936C69.1983 159.978 70.7008 160 72.2182 160C97.309 160 126.453 154.151 155.774 143.272C159.489 141.896 163.203 140.438 166.915 138.9C201.698 124.493 231.892 104.864 251.934 83.628C259.815 75.2776 265.785 67.0383 269.742 59.0586C270.696 57.1384 271.531 55.2355 272.248 53.35C276.11 43.1906 276.382 33.9653 273.053 25.9287Z",
    fill: "url(#paint14_linear_4_179)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.053 25.9287C269.727 17.8946 263.01 11.5632 253.095 7.11248C243.596 2.84707 231.558 0.474649 217.321 0.0644182C188.136 -0.778285 152.903 6.6899 118.12 21.0999C115.619 22.1353 113.14 23.198 110.688 24.2878L114.156 24.2977C115.643 23.6527 117.143 23.0176 118.656 22.3924C189.92 -7.12451 258.604 -5.29824 271.761 26.465C275.572 35.6631 274.314 46.376 268.872 57.6747C255.53 85.3974 217.01 116.637 166.379 137.608C161.48 139.637 156.577 141.525 151.682 143.272C121.98 153.879 92.6432 159.254 67.7526 158.535C53.6985 158.129 41.8438 155.799 32.5123 151.61C22.9311 147.31 16.4589 141.228 13.2734 133.535C10.3993 126.593 10.4092 118.789 12.9274 110.52L11.8524 109.307C8.90173 118.421 8.94127 126.742 11.9785 134.072C15.3073 142.106 22.0217 148.437 31.9389 152.888C41.4385 157.153 53.4736 159.526 67.7106 159.936C69.1983 159.978 70.7008 160 72.2182 160C97.309 160 126.453 154.151 155.774 143.272C159.489 141.896 163.203 140.438 166.915 138.9C201.698 124.493 231.892 104.864 251.934 83.628C259.815 75.2776 265.785 67.0383 269.742 59.0586C270.696 57.1384 271.531 55.2355 272.248 53.35C276.11 43.1906 276.382 33.9653 273.053 25.9287Z",
    fill: "url(#paint15_radial_4_179)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M273.053 25.9287C269.727 17.8946 263.01 11.5632 253.095 7.11248C243.596 2.84707 231.558 0.474649 217.321 0.0644182C188.136 -0.778285 152.903 6.6899 118.12 21.0999C115.619 22.1353 113.14 23.198 110.688 24.2878L114.156 24.2977C115.643 23.6527 117.143 23.0176 118.656 22.3924C189.92 -7.12451 258.604 -5.29824 271.761 26.465C275.572 35.6631 274.314 46.376 268.872 57.6747C255.53 85.3974 217.01 116.637 166.379 137.608C161.48 139.637 156.577 141.525 151.682 143.272C121.98 153.879 92.6432 159.254 67.7526 158.535C53.6985 158.129 41.8438 155.799 32.5123 151.61C22.9311 147.31 16.4589 141.228 13.2734 133.535C10.3993 126.593 10.4092 118.789 12.9274 110.52L11.8524 109.307C8.90173 118.421 8.94127 126.742 11.9785 134.072C15.3073 142.106 22.0217 148.437 31.9389 152.888C41.4385 157.153 53.4736 159.526 67.7106 159.936C69.1983 159.978 70.7008 160 72.2182 160C97.309 160 126.453 154.151 155.774 143.272C159.489 141.896 163.203 140.438 166.915 138.9C201.698 124.493 231.892 104.864 251.934 83.628C259.815 75.2776 265.785 67.0383 269.742 59.0586C270.696 57.1384 271.531 55.2355 272.248 53.35C276.11 43.1906 276.382 33.9653 273.053 25.9287Z",
    fill: "url(#paint16_radial_4_179)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_179",
    x1: 142.469,
    y1: 74.7559,
    x2: 142.469,
    y2: 135.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_179",
    x1: 0,
    y1: 80.0001,
    x2: 285.034,
    y2: 80.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#35E8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2D45C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_179",
    x1: 142.516,
    y1: 91.9115,
    x2: 142.516,
    y2: 136.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28203E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121214",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_179",
    x1: 28.7906,
    y1: 61.0154,
    x2: 28.7906,
    y2: 78.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_179",
    x1: 61.9996,
    y1: 61.0151,
    x2: 61.9996,
    y2: 78.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_179",
    x1: 100.196,
    y1: 61.0151,
    x2: 100.196,
    y2: 78.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_179",
    x1: 140.153,
    y1: 61.0153,
    x2: 140.153,
    y2: 78.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_179",
    x1: 179.363,
    y1: 61.0151,
    x2: 179.363,
    y2: 78.4549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_179",
    x1: 212.594,
    y1: 61.015,
    x2: 212.594,
    y2: 78.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_179",
    x1: 247.009,
    y1: 61.0154,
    x2: 247.009,
    y2: 78.4552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_179",
    x1: 258.619,
    y1: 114.544,
    x2: 66.1068,
    y2: 115.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#35E8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2D45C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_4_179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.758 146.212) rotate(15.7611) scale(129.411 214.897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171226",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4_179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.94 25.0002) rotate(-157.036) scale(29.1264 48.3668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#261945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261945",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4_179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(273.485 107.273) rotate(76.7293) scale(33.0025 54.8033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_179",
    x1: 149.849,
    y1: 17.7274,
    x2: 192.879,
    y2: 126.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#35E8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2D45C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4_179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.03 27.4244) rotate(-19.3523) scale(65.8413 109.335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171225",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4_179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9698 108.788) rotate(67.4706) scale(44.2891 73.5456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191327",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285.034,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.496697623c69c812e753e83681c192f1.svg";
export { ForwardRef as ReactComponent };